export const AI_ENDPOINTS = {
  chat: '/api/chat',
  vision: '/api/vision',
  health: '/api/health',
} as const;

export const AI_TIMEOUTS_MS = {
  request: 15_000,
  vision: 12_000,
  health: 5_000,
  healthRetryDelay: 500,
} as const;

export type AIEndpointPath = (typeof AI_ENDPOINTS)[keyof typeof AI_ENDPOINTS];
